// Tailwind class recipes shared by `DataTable` and hand-written tables that need
// the same behaviour. Kept out of the component file so that file exports only
// components (the react-refresh rule).

import { cn } from "@/lib/utils";

// Marks a table row as the styling anchor for its pinned cell, and keeps the row
// highlighted while an actions menu inside it is open — otherwise the highlight
// drops the moment the pointer leaves for the (portalled) menu and nothing says
// which row is being acted on. Radix marks the open trigger `data-state="open"`,
// and the trigger is a descendant of the row, so the row styles itself from its
// own content. Scoped to `[aria-haspopup="menu"]` so an open Select elsewhere in
// the row can't light it.
export const TABLE_ROW_GROUP_CLASS = cn(
  "group/row",
  "has-[[aria-haspopup=menu][data-state=open]]:bg-row-hover"
);

// Pins a cell against the right edge so the other columns scroll under it.
//
// Opaque at rest so those columns can't show through. On hover it paints the SAME
// opaque colour the row does — both must be opaque, or two translucent fills
// composite and render this one cell darker than the rest of the band.
//
// Requires `TABLE_ROW_GROUP_CLASS` on the enclosing row.
export const PINNED_COLUMN_CLASS = cn(
  "sticky right-0 z-10 bg-background",
  "group-hover/row:bg-row-hover",
  "group-has-[[aria-haspopup=menu][data-state=open]]/row:bg-row-hover"
);
